export const handlePatientIdChange = (
e,
setPatientId,
setEmiratesId,
setEmiratesYear,
setErrorMessage,
setEmiratesIdError,
translationMap) =>
{
  let value = e.target.value;
  value = value.replace(/[^0-9]/g, "");

  if (value.length > 10) {
    value = value.slice(0, 10);
  }

  setPatientId(value);
  setEmiratesIdError("");

  if (value === "") {
    setErrorMessage("");
  } else if (value.length >= 7 && value.length <= 10) {
    setErrorMessage("");
  } else {
    setErrorMessage(translationMap?.mrnShouldBeSevenToTen);
  }

  if (value) {
    setEmiratesId("");
    setEmiratesYear("");
  }
};


export const handleYearChange = (
e,
setYearFunc,
setErrorMessage,
translationMap) =>
{
  let value = e.target.value.replace(/\D/g, "");
  if (value.length > 4) {
    value = value.slice(0, 4);
  }
  setYearFunc(value);

  if (value === "") {
    setErrorMessage("");
  } else if (value.length !== 4) {
    setErrorMessage(translationMap?.yearShouldBeFour);
  } else {
    setErrorMessage("");
  }
};

export const handleEmiratesIdChange = (
e,
setEmiratesId,
setPatientId,
setPatientYear,
setErrorMessage,
setMrnError,
translationMap) =>
{
  let value = e.target.value.replace(/\D/g, "");
  if (value.length > 15) {
    value = value.slice(0, 15);
  }
  setEmiratesId(value);
  setMrnError("");
  if (value === "") {
    setErrorMessage("");
  } else if (value.length !== 15) {
    setErrorMessage(translationMap?.emiratesShouldBeFifteen);
  } else {
    const formatted = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(
      7,
      14
    )}-${value.slice(14)}`;
    setEmiratesId(formatted);
    setErrorMessage("");
  }

  if (value) {
    setPatientId("");
    setPatientYear("");
  }
};